import { Provider } from '@angular/core';

/**
 * Build-configuration provider seam for the root injector. Empty in real
 * builds; the "mock" configuration file-replaces this file with
 * app.providers.mock.ts (see angular.json fileReplacements) to stub the
 * Azure AD / MSAL token acquisition for service-user ("/service") flows.
 *
 * Root-level on purpose: ServiceAccountAuthService is providedIn: 'root',
 * so overriding it inside the lazy-loaded qiasphere.mock.module would only
 * create a second, shadowed instance (see the warning in that module).
 */
export const environmentProviders: Provider[] = [];
